import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { rememberReturnTo } from "./lib/returnTo";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";
import { APP_STAFF_ROLES, pathAllowedForUser, firstAllowedPath, isFullAdmin } from "./pages/DashboardLayout";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import SetPasswordPublic from "./pages/SetPasswordPublic";
import DashboardLayout from "./pages/DashboardLayout";
import { HUB_PAGES } from "./pages/hubs";
import DojovaLanding from "./pages/DojovaLanding";
import { PublicPage } from "./components/public/PublicShell";
import { LEGACY_REDIRECTS } from "./lib/legacyRoutes";
import RedressementModule from "./pages/RedressementModule";
import DojoLanding from "./pages/DojoLanding";
import AcademiePublic from "./pages/AcademiePublic";
import DefisPublic from "./pages/DefisPublic";
import FQJJBPublic from "./pages/FQJJBPublic";
import DefiImpact60Public from "./pages/DefiImpact60Public";
import DefiImpact60Results from "./pages/DefiImpact60Results";
import RentreePromoPublic from "./pages/RentreePromoPublic";
import DefiImpact60Module from "./pages/DefiImpact60Module";
import TasksCenterModule from "./pages/TasksCenterModule";
import ReceptionModule from "./pages/ReceptionModule";
import SubventionsModule from "./pages/SubventionsModule";
import AthleteDetail from "./pages/AthleteDetail";
import ReglementsModule from "./pages/ReglementsModule";
import MatchValidator from "./pages/MatchValidator";
import Profile from "./pages/Profile";
import ProjectDetail from "./pages/ProjectDetail";
import Integrations from "./pages/Integrations";
import RegistreMaitreModule from "./pages/RegistreMaitreModule";
import ReglementSecuritePublic from "./pages/ReglementSecuritePublic";
import BlogPublic from "./pages/BlogPublic";
import BlogPostDetail from "./pages/BlogPostDetail";
import BlogAdmin from "./pages/BlogAdmin";
import BlogEditor from "./pages/BlogEditor";
import ContactAdmin from "./pages/ContactAdmin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import DataDeletion from "./pages/DataDeletion";
import StudentContractsModule from "./pages/StudentContractsModule";
import AttendanceModule from "./pages/AttendanceModule";
import TechniquePublic from "./pages/TechniquePublic";
import PlansPublic from "./pages/PlansPublic";
import HealthPassPublic from "./pages/HealthPassPublic";
import MemberSpacePublic from "./pages/MemberSpacePublic";
import InscriptionPublic from "./pages/InscriptionPublic";
import AdhesionPublic from "./pages/AdhesionPublic";
import PendingInscriptionsModule from "./pages/PendingInscriptionsModule";
import SocialInboxModule from "./pages/SocialInboxModule";
import ProgrammeEcolesModule from "./pages/ProgrammeEcolesModule";
import ProgrammeAmikobiModule from "./pages/ProgrammeAmikobiModule";
import AmikobiTelecommande from "./pages/AmikobiTelecommande";
import AcademieAdminModule from "./pages/AcademieAdminModule";
import StructureAcademiqueModule from "./pages/StructureAcademiqueModule";
import InsuranceClaimsModule from "./pages/InsuranceClaimsModule";
import InscriptionEcolePublic from "./pages/InscriptionEcolePublic";
import PetitsSamouraisModule from "./pages/PetitsSamouraisModule";
import AccueilPilotageModule from "./pages/AccueilPilotageModule";
import AutomatisationsModule from "./pages/AutomatisationsModule";
import RapportsModule from "./pages/RapportsModule";
import PowerKickHerModule from "./pages/PowerKickHerModule";
import InscriptionSamouraisPublic from "./pages/InscriptionSamouraisPublic";
import TarifsPublic from "./pages/TarifsPublic";
import BookingAdminModule from "./pages/BookingAdminModule";
import RetentionModule from "./pages/RetentionModule";
import OnboardingSequenceModule from "./pages/OnboardingSequenceModule";
import FollowUpModule from "./pages/FollowUpModule";
import MigrationActivationModule from "./pages/MigrationActivationModule";
import AuditMembresActifsModule from "./pages/AuditMembresActifsModule";
import FranchisePackModule from "./pages/FranchisePackModule";
import PartnersModule from "./pages/PartnersModule";
import FranchiseLanding from "./pages/FranchiseLanding";
import PartenairesPublic from "./pages/PartenairesPublic";
import PartenariatFournisseurs from "./pages/PartenariatFournisseurs";
import PartnershipsModule from "./pages/PartnershipsModule";
import FournisseursB2BModule from "./pages/FournisseursB2BModule";
import CoachingClientDetail from "./pages/CoachingClientDetail";
import CoachingClientPortal from "./pages/CoachingClientPortal";
import CoachCockpitModule from "./pages/CoachCockpitModule";
import CoachSpacePublic from "./pages/CoachSpacePublic";
import EquipePublic from "./pages/EquipePublic";
import PetitsSamouraisInfo from "./pages/PetitsSamouraisInfo";
import EquipementSamouraisPublic from "./pages/EquipementSamouraisPublic";
import MiniCompetitionsModule from "./pages/MiniCompetitionsModule";
import SponsorsModule from "./pages/SponsorsModule";
import CompetitionPublicRegister from "./pages/CompetitionPublicRegister";
import JmInscriptionPublic from "./pages/JmInscriptionPublic";
import EspaceParentSamourais from "./pages/EspaceParentSamourais";
import CataleyModule from "./pages/CataleyModule";
import BrebeufDossier from "./pages/BrebeufDossier";
import EspaceEvolution from "./pages/EspaceEvolution";
import CataleyEnfant from "./pages/CataleyEnfant";
import NotreEngagementPublic from "./pages/NotreEngagementPublic";
import PolitiquesPublic from "./pages/PolitiquesPublic";
import StandardQualiteModule from "./pages/StandardQualiteModule";
import AvatarStudioModule from "./pages/AvatarStudioModule";
import EventDebriefsModule from "./pages/EventDebriefsModule";
import DebriefPublicResponse from "./pages/DebriefPublicResponse";
import TicketingModule from "./pages/TicketingModule";
import TicketingEventPublic from "./pages/TicketingEventPublic";
import TicketingOrderConfirmation from "./pages/TicketingOrderConfirmation";
import LivestreamModule from "./pages/LivestreamModule";
import LivestreamEventPublic from "./pages/LivestreamEventPublic";
import LivestreamViewerPortal from "./pages/LivestreamViewerPortal";
import LivestreamOrderConfirmation from "./pages/LivestreamOrderConfirmation";
import OnboardingPage from "./pages/OnboardingPage";
import OnboardingLinksModule from "./pages/OnboardingLinksModule";
import QREssaiModule from "./pages/QREssaiModule";
import DocsViewerModule from "./pages/DocsViewerModule";
import NotFound from "./pages/NotFound";
import PublicBookingPage from "./pages/PublicBookingPage";
import AutodefenseFemmes from "./pages/AutodefenseFemmes";
import RythmesConnexionsPublic from "./pages/rythmes/RythmesConnexionsPublic";
import RythmesParcours from "./pages/rythmes/RythmesParcours";
import RythmesFiche from "./pages/rythmes/RythmesFiche";
import DojovaBrand from "./pages/DojovaBrand";
import RythmesAdminModule from "./pages/RythmesAdminModule";
import PowerKickHerLanding from "./pages/PowerKickHerLanding";
import PreinscriptionPowerKickHer from "./pages/PreinscriptionPowerKickHer";
import PowerKickHerCarnet from "./pages/PowerKickHerCarnet";
import PowerKickHerSurvey from "./pages/PowerKickHerSurvey";
import ReunionConfirmer from "./pages/ReunionConfirmer";
import AvisGoogleModule from "./pages/AvisGoogleModule";
import ThemeToggle, { applyTheme, getTheme } from "./components/ThemeToggle";
import HeyGenAvatarModule from "./pages/HeyGenAvatarModule";
import MascottesModule from "./pages/MascottesModule";
import DeploymentStatusModule from "./pages/DeploymentStatusModule";
import CamillePhoneModule from "./pages/CamillePhoneModule";
import BoutiqueDropship from "./pages/BoutiqueDropship";
import CoursEssaiGratuit from "./pages/CoursEssaiGratuit";
const LegacyEssaiRedirect = () => { const { search } = useLocation(); return <Navigate to={`/cours-essai${search}`} replace />; };
import EtapeIntegrationPublic from "./pages/EtapeIntegrationPublic";
import CRMLeadsModule from "./pages/CRMLeadsModule";
import ConversionFunnelModule from "./pages/ConversionFunnelModule";
import ProspectCenterModule from "./pages/ProspectCenterModule";
import WordPressSyncModule from "./pages/WordPressSyncModule";
import CarnetProgressionModule from "./pages/CarnetProgressionModule";
import EvaluationLiveModule from "./pages/EvaluationLiveModule";
import CertificatsModule from "./pages/CertificatsModule";
import ImmeublesModule from "./pages/ImmeublesModule";
import SignerBailPublic from "./pages/SignerBailPublic";
import SignContractPublic from "./pages/SignContractPublic";
import ConsentementPublic from "./pages/ConsentementPublic";
import EntentePublic from "./pages/EntentePublic";
import MediathequeModule from "./pages/MediathequeModule";
import ProgrammesModule from "./pages/ProgrammesModule";
import UniversHub from "./pages/UniversHub";
import BoutiqueAccueil from "./pages/BoutiqueAccueil";
import MembrePortail from "./pages/MembrePortail";
import TrainingSessionsModule from "./pages/TrainingSessionsModule";
import MemberTrainingSession from "./pages/MemberTrainingSession";
import ApercuMembre from "./pages/ApercuMembre";
import ReglesCommunaute from "./pages/ReglesCommunaute";
import MembreVerify from "./pages/MembreVerify";
import ParrainagePublic from "./pages/ParrainagePublic";
import PromoProduit from "./pages/PromoProduit";
import Ete2026Landing from "./pages/Ete2026Landing";
import NouveauMembreGuide from "./pages/NouveauMembreGuide";
import Commencer from "./pages/Commencer";
import TechniquesCatalogueModule from "./pages/TechniquesCatalogueModule";
import PrivateLessonsModule, { PrivateClientDetail } from "./pages/PrivateLessonsModule";
import CurriculumLibraryModule from "./pages/CurriculumLibraryModule";
import CurriculumCoverageModule from "./pages/CurriculumCoverageModule";
import AnomaliesModule from "./pages/AnomaliesModule";
import InvestmentModule from "./pages/InvestmentModule";
import TechniqueVideosModule from "./pages/TechniqueVideosModule";
// Modules YouTube retirés (migration Bunny Stream) : CurriculumVideoBulkModule, PlaylistImportModule
import FinancementModule from "./pages/FinancementModule";
import DossierSinistreModule from "./pages/DossierSinistreModule";
import MembresFacturation from "./pages/MembresFacturation";
import BouclierFiscalModule from "./pages/BouclierFiscalModule";
import ProspectsModule from "./pages/ProspectsModule";
import BoutiquePaiement from "./pages/BoutiquePaiement";
import CommanditesPublic from "./pages/CommanditesPublic";
import CommanditesPaiement from "./pages/CommanditesPaiement";
import CommanditesAdmin from "./pages/CommanditesAdmin";
import PlateformeLanding from "./pages/plateforme/PlateformeLanding";
import DisciplineDetail from "./pages/plateforme/DisciplineDetail";
import PlateformeFondateur from "./pages/plateforme/PlateformeFondateur";
import PlateformeLogin from "./pages/plateforme/PlateformeLogin";
import PlateformeTemoignages from "./pages/plateforme/PlateformeTemoignages";
import PlateformeEssai from "./pages/plateforme/PlateformeEssai";
import PlateformeReseauCoachs from "./pages/plateforme/PlateformeReseauCoachs";
import PlateformeReseauCoachsAdmin from "./pages/plateforme/PlateformeReseauCoachsAdmin";
import PublicCarnetView from "./pages/PublicCarnetView";
import PartnerPortalPublic from "./pages/PartnerPortalPublic";
import MemberPass from "./pages/MemberPass";
import AllPagesModule from "./pages/AllPagesModule";
import PilotageHub from "./pages/PilotageHub";
import TourneePublic from "./pages/TourneePublic";
import TourneeAvis from "./pages/TourneeAvis";
import TourneeRegionaleModule from "./pages/TourneeRegionaleModule";
import ArchivesGdnModule from "./pages/ArchivesGdnModule";
import KioskMode from "./pages/KioskMode";
import CoachTabletPage from "./pages/CoachTabletPage";
import ContactUpdatePublic from "./pages/ContactUpdatePublic";
import FeaturedRewardsModule from "./pages/FeaturedRewardsModule";
import MemberReconciliationModule from "./pages/MemberReconciliationModule";
import HorairePublic from "./pages/HorairePublic";
import VideoTechAdminModule from "./pages/VideoTechAdminModule";
import PremierMoisModule from "./pages/PremierMoisModule";
// import YoutubeTriageModule retiré (migration Bunny Stream)
import VideosTechPublic from "./pages/VideosTechPublic";
import EvenementsPublic from "./pages/EvenementsPublic";
import HoraireEte2026 from "./pages/HoraireEte2026";
import AdmissionPublic from "./pages/AdmissionPublic";
import AdmissionCandidatesModule from "./pages/AdmissionCandidatesModule";
import AuthCallback from "./pages/AuthCallback";
import AdminsModule from "./pages/AdminsModule";
import EspaceAdminPage from "./pages/EspaceAdminPage";
import LiveScoreboardPublic from "./pages/LiveScoreboardPublic";
import JmScoreTable from "./pages/JmScoreTable";
import JmScoreScreen from "./pages/JmScoreScreen";
import JmScoringPilotModule from "./pages/JmScoringPilotModule";
import JmJudgePage from "./pages/JmJudgePage";
import JmPrJudgePage from "./pages/JmPrJudgePage";
import JmLiveScreen from "./pages/JmLiveScreen";
import JmPodiumScreen from "./pages/JmPodiumScreen";
import JmResultsPublic from "./pages/JmResultsPublic";
import JmDossierPublic from "./pages/JmDossierPublic";
import JmCheckinPublic from "./pages/JmCheckinPublic";
import JmOfficialPage from "./pages/JmOfficialPage";
import RentreeMeetingModule from "./pages/RentreeMeetingModule";
import RentreeAideMemoirePublic from "./pages/RentreeAideMemoirePublic";
import SondageMembresPublic from "./pages/SondageMembresPublic";
import TechniquesRevisionPublic from "./pages/TechniquesRevisionPublic";
import AuditRentreeModule from "./pages/AuditRentreeModule";
import AcademieKaizenModule from "./pages/AcademieKaizenModule";
import CheckinEssaiModule from "./pages/CheckinEssaiModule";
// Détecte le retour de Google Auth (session_id dans le fragment) AVANT le rendu des routes,
// pour éviter toute race condition avec la vérification de session.
function GoogleAuthGate({ children }) {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return children;
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Chargement…</div>;
  if (!user) { rememberReturnTo(location.pathname + location.search + location.hash); return <Navigate to="/auth" replace />; }
  const roles = user.roles || [];
  const isStaff = user.is_admin || user.role === "admin" || roles.some((r) => APP_STAFF_ROLES.includes(r));
  // 🔒 SÉCURITÉ : seuls admins + équipe (coach/comptable/réception/marketing) voient /app/*
  if (!isStaff) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-zinc-950 text-zinc-200">
        <div className="max-w-md text-center">
          <div className="text-6xl mb-4">🔒</div>
          <h1 className="text-xl font-bold text-amber-400 mb-2">Accès restreint</h1>
          <p className="text-sm text-zinc-400 mb-4">
            Cette section est réservée à l'administration du dojo. Si tu cherches ton carnet de progression ou la boutique, retourne au site public.
          </p>
          <div className="flex gap-2 justify-center">
            <a href="/" className="px-4 py-2 rounded bg-amber-700 hover:bg-amber-600 text-amber-50 text-sm">Page d'accueil</a>
            <a href="/store" className="px-4 py-2 rounded bg-zinc-800 hover:bg-zinc-700 text-sm">Boutique</a>
          </div>
        </div>
      </div>
    );
  }
  // 🔐 RBAC : un membre d'équipe ne peut ouvrir que les pôles autorisés à son rôle.
  if (!isFullAdmin(user) && !pathAllowedForUser(location.pathname, user)) {
    // Redirige vers son premier pôle autorisé (ex. accès PKH seul → /app/powerkick-her)
    const home = firstAllowedPath(user);
    if (home && home !== location.pathname && home !== "/app") {
      return <Navigate to={home} replace />;
    }
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-zinc-950 text-zinc-200">
        <div className="max-w-md text-center" data-testid="rbac-denied">
          <div className="text-6xl mb-4">⛔</div>
          <h1 className="text-xl font-bold text-amber-400 mb-2">Section non autorisée</h1>
          <p className="text-sm text-zinc-400 mb-4">
            Ton rôle ({(user.roles || [user.role]).join(", ")}) n'a pas accès à cette section. Reviens à ton tableau de bord.
          </p>
          <a href="/app" className="px-4 py-2 rounded bg-amber-700 hover:bg-amber-600 text-amber-50 text-sm">Mon tableau de bord</a>
        </div>
      </div>
    );
  }
  return children;
}

function PublicThemeToggle() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/app")) return null;
  return <ThemeToggle />;
}

function App() {
  useEffect(() => { document.title = "Mon Assistant Pro"; applyTheme(getTheme()); }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <PublicThemeToggle />
        <GoogleAuthGate>
        <Routes>
          <Route path="/" element={<DojoLanding />} />
          <Route path="/kaizen" element={<Landing />} />
          <Route path="/plateforme" element={<PlateformeLanding />} />
          <Route path="/dojova" element={<DojovaLanding />} />
          <Route path="/dojova/marque" element={<DojovaBrand />} />
          <Route path="/plateforme/disciplines/:slug" element={<DisciplineDetail />} />
          <Route path="/plateforme/fondateur" element={<PlateformeFondateur />} />
          <Route path="/plateforme/login" element={<PlateformeLogin />} />
          <Route path="/plateforme/temoignages" element={<PlateformeTemoignages />} />
          <Route path="/plateforme/essai-gratuit" element={<PlateformeEssai />} />
          <Route path="/plateforme/reseau-coachs" element={<PlateformeReseauCoachs />} />
          <Route path="/plateforme/reseau-coachs/admin" element={<PlateformeReseauCoachsAdmin />} />
          <Route path="/promo/gladiateur2026" element={<Navigate to="/" replace />} />
          <Route path="/franchise" element={<PublicPage><FranchiseLanding /></PublicPage>} />
          <Route path="/partenaires" element={<PublicPage><PartenairesPublic /></PublicPage>} />
          <Route path="/partenaire/:token" element={<PartnerPortalPublic />} />
          <Route path="/partenariat-fournisseurs" element={<PartenariatFournisseurs />} />
          <Route path="/partenariat" element={<PartenariatFournisseurs />} />
          <Route path="/site-preview/gala-v" element={<Navigate to="/" replace />} />
          <Route path="/circuit" element={<Navigate to="/" replace />} />
          <Route path="/blog" element={<BlogPublic />} />
          <Route path="/blog/:slug" element={<BlogPostDetail />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/definir-mot-de-passe" element={<SetPasswordPublic />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<PublicPage><TermsOfService /></PublicPage>} />
          <Route path="/terms-of-service" element={<PublicPage><TermsOfService /></PublicPage>} />
          <Route path="/conditions-utilisation" element={<PublicPage><TermsOfService /></PublicPage>} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          <Route path="/pass/:token" element={<HealthPassPublic />} />
          <Route path="/me/:token" element={<MemberSpacePublic />} />
          <Route path="/carnet/:token" element={<PublicCarnetView />} />
          <Route path="/carte-membre/:token" element={<MemberPass />} />
          <Route path="/kiosque" element={<KioskMode />} />
          <Route path="/tablette-coach" element={<CoachTabletPage />} />
          <Route path="/contact-update/:token" element={<ContactUpdatePublic />} />
          <Route path="/signer-bail/:token" element={<SignerBailPublic />} />
          <Route path="/signer-contrat" element={<SignContractPublic />} />
          <Route path="/consentement/:token" element={<ConsentementPublic />} />
          <Route path="/entente/:token" element={<EntentePublic />} />
          <Route path="/tech/:id" element={<TechniquePublic />} />
          <Route path="/plans" element={<PublicPage><PlansPublic /></PublicPage>} />
          <Route path="/plans/:userIdOrSlug" element={<PublicPage><PlansPublic /></PublicPage>} />
          <Route path="/inscription" element={<InscriptionPublic />} />
          <Route path="/inscription-ecole/:token" element={<InscriptionEcolePublic />} />
          <Route path="/petits-samourais" element={<PublicPage><InscriptionSamouraisPublic /></PublicPage>} />
          <Route path="/petits-samourais/equipement" element={<EquipementSamouraisPublic />} />
          <Route path="/equipement/:program" element={<EquipementSamouraisPublic />} />
          <Route path="/espace-parent/:token" element={<EspaceParentSamourais />} />
          <Route path="/cataley/:token" element={<CataleyEnfant />} />
          <Route path="/notre-engagement" element={<NotreEngagementPublic />} />
          <Route path="/standard-professionnel" element={<NotreEngagementPublic />} />
          <Route path="/politiques" element={<PublicPage><PolitiquesPublic /></PublicPage>} />
          <Route path="/admission" element={<PublicPage><AdmissionPublic /></PublicPage>} />
          <Route path="/tarifs" element={<PublicPage><TarifsPublic /></PublicPage>} />
          <Route path="/adhesion" element={<AdhesionPublic />} />
          <Route path="/adhesion/merci" element={<AdhesionPublic />} />
          <Route path="/boutique" element={<Navigate to="/store" replace />} />
          <Route path="/store" element={<BoutiqueDropship />} />
          <Route path="/horaire" element={<HorairePublic />} />
          <Route path="/videos" element={<VideosTechPublic />} />
          <Route path="/evenements" element={<EvenementsPublic />} />
          <Route path="/tournee" element={<TourneePublic />} />
          <Route path="/tournee/avis" element={<TourneeAvis />} />          <Route path="/kaizen-en-ligne" element={<Navigate to="/academie" replace />} />
          <Route path="/cours-en-ligne" element={<Navigate to="/academie" replace />} />
          <Route path="/curriculum-en-ligne" element={<Navigate to="/academie" replace />} />
          <Route path="/boutique-accueil" element={<PublicPage><BoutiqueAccueil /></PublicPage>} />
          <Route path="/univers" element={<PublicPage><UniversHub /></PublicPage>} />
          <Route path="/membres" element={<MembrePortail />} />
          <Route path="/membres/:section" element={<MembrePortail />} />
          <Route path="/regles-communaute" element={<PublicPage><ReglesCommunaute /></PublicPage>} />
          <Route path="/academie" element={<PublicPage><AcademiePublic /></PublicPage>} />
          <Route path="/defis" element={<PublicPage><DefisPublic /></PublicPage>} />
          <Route path="/fqjjb" element={<FQJJBPublic />} />
          <Route path="/defi-impact-60" element={<DefiImpact60Public />} />
          <Route path="/defi-impact-60/resultats" element={<DefiImpact60Results />} />
          <Route path="/rentree" element={<RentreePromoPublic />} />
          <Route path="/back-to-school" element={<RentreePromoPublic />} />
          <Route path="/tableau-fqjjb" element={<FQJJBPublic />} />
          <Route path="/portail-client" element={<Navigate to="/membres" replace />} />
          <Route path="/membres/verifier" element={<MembreVerify />} />
          <Route path="/parrainage/:code" element={<ParrainagePublic />} />
          <Route path="/promo/:slug" element={<PromoProduit />} />
          <Route path="/cours-essai" element={<PublicPage><CoursEssaiGratuit /></PublicPage>} />
          <Route path="/cours-essai-gratuit" element={<LegacyEssaiRedirect />} />
          <Route path="/etape-integration/:tid" element={<EtapeIntegrationPublic />} />
          <Route path="/essai" element={<PublicPage><CoursEssaiGratuit /></PublicPage>} />
          <Route path="/boutique/paiement" element={<BoutiquePaiement />} />
          <Route path="/commandites" element={<CommanditesPublic />} />
          <Route path="/commandites/paiement" element={<CommanditesPaiement />} />
          <Route path="/user-data-deletion" element={<DataDeletion />} />
          {/* Slugs FR (alignés avec WordPress + exigences Meta) */}
          <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
          <Route path="/suppression-des-donnees" element={<DataDeletion />} />
          <Route path="/essai-gratuit" element={<Navigate to="/cours-essai?src=essai-gratuit" replace />} />
          <Route path="/ete-2026" element={<Ete2026Landing />} />
          <Route path="/ete" element={<Ete2026Landing />} />
          <Route path="/horaire-ete-2026" element={<HoraireEte2026 />} />
          <Route path="/bienvenue" element={<PublicPage><NouveauMembreGuide /></PublicPage>} />
          <Route path="/guide-nouveau-membre" element={<PublicPage><NouveauMembreGuide /></PublicPage>} />
          <Route path="/commencer" element={<Commencer />} />
          <Route path="/start" element={<Commencer />} />
          <Route path="/reserver-prive" element={<PublicBookingPage />} />
          <Route path="/autodefense-femmes" element={<AutodefenseFemmes />} />
          <Route path="/rythmes-connexions" element={<RythmesConnexionsPublic />} />
          <Route path="/rythmes/mon-parcours" element={<RythmesParcours />} />
          <Route path="/rythmes/verifier" element={<RythmesParcours />} />
          <Route path="/rythmes/fiche/:numero" element={<RythmesFiche />} />
          <Route path="/powerkick-her" element={<PowerKickHerLanding />} />
          <Route path="/powerkick-her/preinscription" element={<PreinscriptionPowerKickHer />} />
          <Route path="/powerkick-her/carnet" element={<PowerKickHerCarnet />} />
          <Route path="/sondage-pkh" element={<PowerKickHerSurvey />} />
          <Route path="/reunion/:mid/confirmer" element={<ReunionConfirmer />} />
          <Route path="/coaching-prive/portail/:slug" element={<CoachingClientPortal />} />
          <Route path="/competitions/:slug" element={<CompetitionPublicRegister />} />
          <Route path="/competitions/:slug/inscription" element={<JmInscriptionPublic />} />
          <Route path="/jeux-martiaux/live/:slug" element={<LiveScoreboardPublic />} />
          <Route path="/jm/table/:token" element={<JmScoreTable />} />
          <Route path="/jm/ecran/live/:competitionId" element={<JmLiveScreen />} />
          <Route path="/jm/ecran/podium/:competitionId" element={<JmPodiumScreen />} />
          <Route path="/amikobi-telecommande" element={<AmikobiTelecommande />} />
          <Route path="/jm/resultats/:competitionId" element={<JmResultsPublic />} />
          <Route path="/jm/dossier/:token" element={<JmDossierPublic />} />
          <Route path="/jm/checkin/:token" element={<JmCheckinPublic />} />
          <Route path="/jm/officiel/:token" element={<JmOfficialPage />} />
          <Route path="/jm/ecran/:matId" element={<JmScoreScreen />} />
          <Route path="/jm/juge/:token/:idx" element={<JmJudgePage />} />
          <Route path="/jm/pr/juge/:token" element={<JmPrJudgePage />} />
          <Route path="/rentree-membres" element={<RentreeAideMemoirePublic />} />
          <Route path="/reglement-securite" element={<ReglementSecuritePublic />} />
          <Route path="/sondage-membres" element={<SondageMembresPublic />} />
          <Route path="/mes-techniques/:slug" element={<TechniquesRevisionPublic />} />
          <Route path="/debrief/:slug" element={<DebriefPublicResponse />} />
          <Route path="/billetterie/:slug" element={<TicketingEventPublic />} />
          <Route path="/billetterie/order/:sessionId" element={<TicketingOrderConfirmation />} />
          <Route path="/livestream/:slug" element={<LivestreamEventPublic />} />
          <Route path="/livestream/order/:sessionId" element={<LivestreamOrderConfirmation />} />
          <Route path="/livestream/portail/:accessToken" element={<LivestreamViewerPortal />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/equipe" element={<EquipePublic />} />
          <Route path="/espace-coach/:slug" element={<CoachSpacePublic />} />
          <Route path="/infos-petits-samourais" element={<PetitsSamouraisInfo />} />
          <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
            <Route index element={<PilotageHub />} />
            {Object.entries(HUB_PAGES).map(([p, Page]) => <Route key={p} path={p.replace("/app/", "")} element={<Page />} />)}
            {Object.entries(LEGACY_REDIRECTS).map(([from, to]) => <Route key={from} path={from.replace("/app/", "")} element={<Navigate to={to} replace />} />)}
            <Route path="competition" element={<Navigate to="/app/mini-competitions" replace />} />
            <Route path="reconciliation-membres" element={<MemberReconciliationModule />} />
            <Route path="store" element={<Navigate to="/store" replace />} />
            <Route path="boutique-public" element={<Navigate to="/store" replace />} />
            <Route path="franchise" element={<Navigate to="/franchise" replace />} />
            <Route path="partenaires" element={<Navigate to="/partenaires" replace />} />
            <Route path="fournisseurs-b2b" element={<FournisseursB2BModule />} />
            <Route path="partenariats" element={<PartnershipsModule />} />
            <Route path="coaching-prive" element={<Navigate to="/app/booking" replace />} />
            <Route path="coachs" element={<CoachCockpitModule />} />
            <Route path="coaching-prive/:id" element={<CoachingClientDetail />} />
            <Route path="mini-competitions" element={<MiniCompetitionsModule />} />
            <Route path="pointage" element={<JmScoringPilotModule />} />
            <Route path="toutes-pages" element={<AllPagesModule />} />
            <Route path="rythmes-connexions" element={<RythmesAdminModule />} />
            <Route path="archives-gdn" element={<ArchivesGdnModule />} />
            <Route path="defi-impact-60" element={<DefiImpact60Module />} />
            <Route path="taches" element={<TasksCenterModule />} />
            <Route path="commandites" element={<SponsorsModule />} />
            <Route path="debriefs" element={<EventDebriefsModule />} />
            <Route path="billetterie" element={<TicketingModule />} />
            <Route path="livestream" element={<LivestreamModule />} />
            <Route path="liens-onboarding" element={<OnboardingLinksModule />} />
            <Route path="qr-essai" element={<QREssaiModule />} />
            <Route path="docs" element={<DocsViewerModule />} />
            <Route path="lettrage-camion" element={<DocsViewerModule />} />
            <Route path="eleves" element={<StudentContractsModule />} />
            <Route path="videos" element={<VideoTechAdminModule />} />
            <Route path="premier-mois" element={<PremierMoisModule />} />
            {/* Route tri-videos (YouTube) retirée — migration Bunny Stream */}
            <Route path="tri-videos" element={<Navigate to="/app/videos" replace />} />
            <Route path="ambassadeurs" element={<FeaturedRewardsModule />} />
            <Route path="presences" element={<AttendanceModule />} />
            <Route path="inscriptions-en-attente" element={<PendingInscriptionsModule />} />
            <Route path="programme-ecoles" element={<ProgrammeEcolesModule />} />
            <Route path="programme-amikobi" element={<ProgrammeAmikobiModule />} />
            <Route path="tournee-regionale" element={<TourneeRegionaleModule />} />
            <Route path="academie" element={<AcademieAdminModule />} />
            <Route path="structure-academique" element={<StructureAcademiqueModule />} />
            <Route path="reclamations-assurance" element={<InsuranceClaimsModule />} />
            <Route path="petits-samourais" element={<PetitsSamouraisModule />} />
            <Route path="cataley" element={<CataleyModule />} />
            <Route path="accueil-pilotage" element={<AccueilPilotageModule />} />
            <Route path="avis-google" element={<AvisGoogleModule />} />
            <Route path="automatisations" element={<AutomatisationsModule />} />
            <Route path="rapports" element={<RapportsModule />} />
            <Route path="entrainements-associes" element={<TrainingSessionsModule />} />
            <Route path="entrainement/:id" element={<MemberTrainingSession />} />
            <Route path="apercu-membre" element={<ApercuMembre />} />
            <Route path="powerkick-her" element={<PowerKickHerModule />} />
            <Route path="booking" element={<BookingAdminModule />} />
            <Route path="clients-prives" element={<PrivateLessonsModule />} />
            <Route path="clients-prives/:id" element={<PrivateClientDetail />} />
            <Route path="retention" element={<RetentionModule />} />
            <Route path="onboarding-sequence" element={<OnboardingSequenceModule />} />
            <Route path="suivi-personnalise" element={<FollowUpModule />} />
            <Route path="activation-membres" element={<MigrationActivationModule />} />
            <Route path="audit-membres" element={<AuditMembresActifsModule />} />
            <Route path="franchise-pack" element={<FranchisePackModule />} />
            <Route path="franchises" element={<PartnersModule />} />
            <Route path="heygen" element={<HeyGenAvatarModule />} />
            <Route path="mascottes" element={<MascottesModule />} />
            <Route path="deploiement" element={<DeploymentStatusModule />} />
            <Route path="camille-phone" element={<CamillePhoneModule />} />
            <Route path="crm-leads" element={<CRMLeadsModule />} />
            <Route path="admission" element={<AdmissionCandidatesModule />} />
            <Route path="conversion-globale" element={<ConversionFunnelModule />} />
            <Route path="centre-suivi" element={<ProspectCenterModule />} />
            <Route path="inbox-sociale" element={<SocialInboxModule />} />
            <Route path="wordpress-sync" element={<WordPressSyncModule />} />
            <Route path="carnet-progression" element={<CarnetProgressionModule />} />
            <Route path="evaluation" element={<EvaluationLiveModule />} />
            <Route path="evaluation/:evalId" element={<EvaluationLiveModule />} />
            <Route path="certificats" element={<CertificatsModule />} />
            <Route path="immeubles" element={<ImmeublesModule />} />
            <Route path="immeubles/dossier-brebeuf" element={<BrebeufDossier />} />
            <Route path="mediatheque" element={<MediathequeModule />} />
            <Route path="programmes-regles" element={<ProgrammesModule />} />
            <Route path="evolution" element={<EspaceEvolution />} />
            <Route path="bibliotheque-techniques" element={<TechniquesCatalogueModule />} />
            <Route path="cours-prives" element={<Navigate to="/app/booking" replace />} />
            <Route path="cours-prives/:id" element={<PrivateClientDetail />} />
            <Route path="curriculums" element={<CurriculumLibraryModule />} />
            <Route path="couverture-curriculum" element={<CurriculumCoverageModule />} />
            <Route path="anomalies" element={<AnomaliesModule />} />
            <Route path="carnet-auto" element={<Navigate to="/app/anomalies#carnet-auto" replace />} />
            <Route path="investissement" element={<InvestmentModule />} />
            <Route path="videos-techniques" element={<TechniqueVideosModule />} />
            {/* Routes videos-groupe & playlists-import (YouTube) retirées — migration Bunny Stream */}
            <Route path="videos-groupe" element={<Navigate to="/app/videos" replace />} />
            <Route path="playlists-import" element={<Navigate to="/app/videos" replace />} />
            <Route path="financement" element={<FinancementModule />} />
            <Route path="dossier-sinistre" element={<DossierSinistreModule />} />
            <Route path="facturation-membres" element={<MembresFacturation />} />
            <Route path="redressement" element={<RedressementModule />} />
            <Route path="bouclier-fiscal" element={<BouclierFiscalModule />} />
            <Route path="prospects-gmail" element={<ProspectsModule />} />
            <Route path="commandites" element={<CommanditesAdmin />} />
            <Route path="subventions" element={<SubventionsModule />} />
            <Route path="reception" element={<ReceptionModule />} />
            <Route path="guide-reception" element={<ReceptionModule guide />} />
            <Route path="athletes/:id" element={<AthleteDetail />} />
            <Route path="reglements" element={<ReglementsModule />} />
            <Route path="match-validator" element={<MatchValidator />} />
            <Route path="blog" element={<BlogAdmin />} />
            <Route path="blog/nouveau" element={<BlogEditor />} />
            <Route path="blog/:id/editer" element={<BlogEditor />} />
            <Route path="contact" element={<ContactAdmin />} />
            <Route path="dossiers/:id" element={<ProjectDetail />} />
            <Route path="profil" element={<Profile />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="reglages" element={<RegistreMaitreModule />} />
            <Route path="administrateurs" element={<AdminsModule />} />
            <Route path="espace-admin" element={<EspaceAdminPage />} />
            <Route path="rencontre-rentree" element={<RentreeMeetingModule />} />
            <Route path="audit-rentree" element={<AuditRentreeModule />} />
            <Route path="standard-qualite" element={<StandardQualiteModule />} />
            <Route path="avatar-studio" element={<AvatarStudioModule />} />
            <Route path="academie-kaizen" element={<AcademieKaizenModule />} />
            <Route path="checkin-essai" element={<CheckinEssaiModule />} />
            {/* Catch-all interne au dashboard : page introuvable */}
            <Route path="*" element={<NotFound />} />
          </Route>
          {/* Catch-all : 404 Page Introuvable (évite les pages blanches) */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </GoogleAuthGate>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
